import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

export const companyUsersNRO: NavigationRoutingObject = {
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("company-users", "Company Users"),
  pageNameForTracking: () => "Company Users",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermissionForAnyScope, isFreeTrial }) => {
    if (featureOn("unified_permission_settings_page")) {
      return false;
    }

    // Please keep this in sync with the logic in the SettingsMenuItems component

    if (isFreeTrial) {
      return hasPermissionForAnyScope("viewFreeTrialDevelopers");
    }

    if (
      featureOn("clip_granular_permission_manage_developers_and_permissions") &&
      featureOn("clip_granular_permissions_all")
    ) {
      return hasPermissionForAnyScope("editDashboardUsers");
    }

    return hasPermissionForAnyScope("manageDevelopersAndPermissions");
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [t("company-users-manage-users", "Manage Users")],
      description: t("previously-manage-users", 'Previously "Manage Users"'),
    },
    {
      keywords: [t("company-users-nro-additional-keyword-invite", "Invite Users")],
      description: t("company-users-nro-additional-description-invite", "Invite Users to Braze"),
    },
  ],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/company_settings/manage_users/:appGroupId",
};
